import type { ComboBoxValueComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Text } from '../../../cdl/Text/Text';
import { formatPort } from '../../../common/helpers/formatPort.helper';
import { Box } from '../../../common/ui/Box';
import { KeyPortHighlight } from '../../../keyport/KeyPortHighlight';
import type { PortOption } from '../PortDetailSelect';

export const PortSingleValue = ({ option }: ComboBoxValueComponentProps<PortOption>) => {
    const formattedPort = formatPort({ port: option.port });

    return (
        <Box display="flex" gap={8} alignItems="center" minWidth={0} overflow="hidden">
            <Text variant="small" title={formattedPort} truncated style={{ flex: '0 1 auto' }}>
                {formattedPort}
            </Text>
            <KeyPortHighlight portId={option.port.id} vesselId={option.vesselId} />
        </Box>
    );
};
